import Cookies from 'utils/GoustoCookies'
import { get } from 'utils/cookieHelper2'

const getSessionId = () => get(Cookies, 'gousto_session_id', false, false)

export const getRequestHeaders = (userId) => {
  const sessionId = getSessionId()

  return {
    'Content-Type': 'application/json',
    ...(sessionId ? { 'x-gousto-device-id': sessionId } : {}),
    ...(userId ? { 'x-gousto-user-id': userId } : {}),
  }
}
